const Home: React.FC = () => {
    return <div>Index</div>;
};

export default Home;
